<template>
  <v-card flat class="my-0">
    <v-card-subtitle class="pb-0">{{ $t("DefaultValue") }}</v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-col v-if="!useToday">
          <BaseDatePicker v-model="defaultValueDateTime" :label="$t('Value')" clearable />
        </v-col>
        <v-col v-if="useToday">
          <v-text-field
            type="number"
            min="0"
            v-model="daysBeforeAfterToday"
          ></v-text-field>
        </v-col>
        <v-col v-if="useToday">
          <v-radio-group v-model="beforeAfter" row>
            <v-radio v-bind:label="$t('DaysBeforeToday')" value="B"></v-radio>
            <v-radio v-bind:label="$t('DaysAfterToday')" value="A"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col>
          <v-checkbox v-model="useToday" :label="$t('Today')" data-testid="use-today"></v-checkbox>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import SearchConstValues from '@/ecm/variables/SearchConstValues';
export default {
    props: {
        field: {
            type: Object,
            default: () => ({}),
        },
        validator: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            openDatePicker: false,
            useToday: false,
            daysBeforeAfterToday: 0,
            beforeAfter: 'B',
        };
    },
    computed: {
        todayValues() {
            return `${this.useToday}|${this.daysBeforeAfterToday}|${this.beforeAfter}`;
        },
        defaultValueDateTime: {
            get: function () {
                return this.parseDefaultValue();
            },
            set: function (newValue) {
                this.setDefaultValue(newValue);
            },
        },
    },
    watch: {
        todayValues() {
            this.setDefaultValue();
        },
    },
    methods: {
        parseDefaultValue() {
            var defaultValueDateTime = '';
            if (this.field.default) {
                if (this.field.default == SearchConstValues.Today) {
                    this.useToday = true;
                } else if (
                    this.field.default.includes(SearchConstValues.DaysBeforeToday)
                ) {
                    this.useToday = true;
                    this.beforeAfter = 'B';
                    this.daysBeforeAfterToday = parseInt(
                        this.field.default
                            .replace(SearchConstValues.DaysBeforeToday, '')
                            .trim()
                    );
                } else if (
                    this.field.default.includes(SearchConstValues.DaysAfterToday)
                ) {
                    this.useToday = true;
                    this.beforeAfter = 'A';
                    this.daysBeforeAfterToday = parseInt(
                        this.field.default
                            .replace(SearchConstValues.DaysAfterToday, '')
                            .trim()
                    );
                } else {
                    defaultValueDateTime = this.field.default;
                }
            }
            return defaultValueDateTime;
        },
        setDefaultValue(newValue) {
            this.field.default = '';
            if (newValue) {
                this.field.default = newValue;
            }
            if (this.useToday) {
                if (this.daysBeforeAfterToday != '' && this.daysBeforeAfterToday > 0) {
                    this.field.default = `${this.daysBeforeAfterToday} ${
                        this.beforeAfter == 'B'
                            ? SearchConstValues.DaysBeforeToday
                            : SearchConstValues.DaysAfterToday
                    }`;
                } else this.field.default = SearchConstValues.Today;
            }
        },
    },
};
</script>

<style>
</style>